<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" id="Pause" width="20" height="20"
  ><path
    d="M12 38h8V10h-8v28zm16-28v28h8V10h-8z"
    fill="#ffffff"
    class="color000000 svgShape"
  /><path fill="none" d="M0 0h48v48H0z" /></svg
>
